import React, { useEffect, useRef, useState } from 'react'
import SplitType from 'split-type'

const TextAnimation = ({
  outerClassName = '',
  className,
  children,
  center = false,
  inView = false,
}) => {
  const firstText = useRef(null)
  const secondText = useRef(null)
  const [delayedInView, setDelayedInView] = useState(false)

  // FUNCTION TO TURN TEXT SPAN ONE BY ONE
  const processText = (content) => {
    function flattenArray(arr) {
      return arr.reduce(
        (acc, val) =>
          Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val),
        [],
      )
    }
    content = flattenArray(content)
    let processed = []
    // CHECK TYPE
    if (typeof content === 'string') {
      // Convert to array directly
      processed[0] = content
      return processed
    } else if (Object.prototype.toString.call(content) === '[object Array]') {
      // contain some inner span
      // restructure content
      // all inner text convert to the same span one by one
      content.forEach((ctn, parentIndex) => {
        if (ctn.type) {
          const splitChar = ctn.props.children.split(' ')
          splitChar.forEach((char, index) => {
            const placeholder = React.createElement(
              ctn.type,
              {
                key: `${index}+${char}+${parentIndex}`,
                className: ctn.props.className,
              },
              char,
            )
            processed.push(placeholder)
            if (index <= splitChar.length - 1) processed.push(' ')
          })
          // Split text to array
        } else {
          processed.push(ctn)
        }
      })
      return processed
    }
  }

  useEffect(() => {
    if (!inView || delayedInView) return // Cegah perubahan jika sudah true

    const mountTimeout = setTimeout(() => {
      setDelayedInView(true)
    }, 750)

    return () => clearTimeout(mountTimeout)
  }, [inView, delayedInView])

  useEffect(() => {
    let timeoutId
    timeoutId = setTimeout(() => {
      if (!firstText.current || !secondText.current) {
        const first = new SplitType(`.text-animation > div:first-child`, {
          types: 'line',
          lineClass: `line ${center ? '!text-center' : ''}`,
        })
        const second = new SplitType(`.text-animation > div:last-child`, {
          types: 'line',
          lineClass: `line ${center ? '!text-center' : ''}`,
        })

        firstText.current = first
        secondText.current = second
      }
    }, 100)

    // Debounced resize handler
    const debounce = (func, timeout = 500) => {
      let timer
      return (...args) => {
        timer = setTimeout(() => func.apply(this, args), timeout)
      }
    }

    let prevW = window.innerWidth

    const handleResize = debounce(() => {
      clearTimeout(timeoutId)
      if (prevW != window.innerWidth) {
        // ONLY SPLITTING IF WIDTH IS DIFFERENT
        // Revert SplitText only, no need to reinitialize it
        firstText.current.revert()
        secondText.current.revert()

        // Re-split the text
        firstText.current.split()
        secondText.current.split()
      }
    })

    window.addEventListener('resize', handleResize)

    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      className={`text-animation relative overflow-hidden ${outerClassName} ${
        delayedInView ? 'reveal' : ''
      }`}
    >
      <div className={`${className}`}>{processText(children)}</div>
      <div className={`absolute top-0 ${center ? "left-1/2 -translate-x-1/2" : "left-0"} ${className}`}>
        {processText(children)}
      </div>
    </div>
  )
}

export default TextAnimation
